import {sortBy} from '../components/common/utils/array';
/* eslint-disable no-underscore-dangle */
const PRIORITY_ASCENDING = 'PRIORITY_ASCENDING';
const CLOSEST_FIRTS = 'CLOSEST_FIRTS';
const FURTHEST_FIRTS = 'FURTHEST_FIRTS';
export const PRIORITY_DESCENDING = 'PRIORITY_DESCENDING';

export const SORTING_OPTIONS = [
  {label: 'high to low', value: PRIORITY_DESCENDING, labelPrefix: 'Priority'},
  {label: 'low to high', value: PRIORITY_ASCENDING, labelPrefix: 'Priority'},
  {label: 'closest first', value: CLOSEST_FIRTS, labelPrefix: 'Target date'},
  {label: 'furthest first', value: FURTHEST_FIRTS, labelPrefix: 'Target date'},
];

export const mapPriorityToNumber = (priority) => {
  switch (priority) {
    case 'LOW':
      return 1;
    case 'MEDIUM':
      return 2;
    case 'HIGH':
      return 3;
    default:
      return 1;
  }
};

export const getTasksSortingFunction = (sort) => {
  switch (sort) {
    case PRIORITY_ASCENDING:
      return sortBy('_pristineProperties', false, (prop) => mapPriorityToNumber(prop.priority));
    case PRIORITY_DESCENDING:
      return sortBy('_pristineProperties', true, (prop) => mapPriorityToNumber(prop.priority));
    case CLOSEST_FIRTS:
      return sortBy('_pristineProperties', false, (prop) =>
        // year 3000 was used because tasks with no target date should always be at the bottom of the sort list
        prop.targetDate ? new Date(prop.targetDate) : new Date(3000, 0, 1)
      );
    case FURTHEST_FIRTS:
      return sortBy('_pristineProperties', true, (prop) =>
        prop.targetDate ? new Date(prop.targetDate) : new Date(1970, 0, 1)
      );
    default:
      return null;
  }
};
